import {AxiosError} from 'axios';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {PUT_START_IMPORT_RESULT_FILE_PROCESSING} from '../../constants/apiUrls';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================

export interface PutStartImportResultsFileProcessing {
  fileUuid: string;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: () => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePutStartImportResultsFileProcessing = ({onSuccess, onError}: Input) => {
  const putStartFileProcessing = async (payload: PutStartImportResultsFileProcessing) => {
    await axiosClient.put<undefined>(PUT_START_IMPORT_RESULT_FILE_PROCESSING(), {
      uuid: payload.fileUuid,
    });
  };

  return useCustomMutation(putStartFileProcessing, {
    onSuccess,
    onError,
  });
};
